class FBRightsCategory {
  constructor(
    description,
    image,
    subtitle,
    title,
    descriptionHash,
    titleHash,
    subtitleHash
  ) {
    this.description = description;
    this.image = image;
    this.subtitle = subtitle;
    this.title = title;
    this.descriptionHash = descriptionHash;
    this.titleHash = titleHash;
    this.subtitleHash = subtitleHash;
  }
}

export default FBRightsCategory;
